/**
 * <s-share> opens the native share sheet for the current page, falling back to
 * copying the link and announcing it.
 *
 * Required markup:
 *   data-url — Absolute URL to share.
 *   data-title — Title passed to the share sheet.
 *   data-copied-message — Translated confirmation text.
 *   button[data-share-button] — Trigger.
 *   [data-share-status] — Polite live region for the confirmation.
 */
class Share extends HTMLElement {
  #ac = null;

  connectedCallback() {
    this.#ac = new AbortController();
    this.querySelector('[data-share-button]')?.addEventListener('click', () => this.#share(), { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  async #share() {
    const url = this.dataset.url || window.location.href;
    const title = this.dataset.title || document.title;

    if (navigator.share) {
      try {
        await navigator.share({ url, title });
      } catch {
        // Dismissed share sheet; nothing to do.
      }
      return;
    }

    try {
      await navigator.clipboard.writeText(url);
      const status = this.querySelector('[data-share-status]');
      if (status) {
        status.textContent = this.dataset.copiedMessage || '';
        setTimeout(() => { status.textContent = ''; }, 3000);
      }
    } catch {
      window.prompt('', url);
    }
  }
}

if (!customElements.get('s-share')) {
  customElements.define('s-share', Share);
}
